if (!window.Eurus.loadedScript.includes('product-cart.js')) {
  window.Eurus.loadedScript.push('product-cart.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xProductCart', (
        wrappringVariantId,
      ) => ({
        loading: false,
        errorMessage: false,
        buttonSubmit: "",
        error_message_wrapper: {},
        stopAction: false,
        t: '',
        async addToCart(e) {
          e.preventDefault();
          var productInfo = this.$el.closest('.product-info');
          if (productInfo) {
            var propertiesInput = productInfo.querySelectorAll(`.customization-picker`);
            this.stopAction = false;
            propertiesInput.length && propertiesInput.forEach((input) => {
              if (input.required && input.value == '' || input.classList.contains("validate-checkbox")) {
                input.classList.add("required-picker");
                this.stopAction = true;
              }
            });
          }
          if (this.stopAction) {
            return true;
          }

          this.loading = true;
          
          if (this.$refs.gift_wrapping_checkbox && this.$refs.gift_wrapping_checkbox.checked && wrappringVariantId) {
            const giftData = {
              items: [
                {
                  id: wrappringVariantId,
                  quantity: 1
                }
              ]
            };
    
            const giftResponse = await window.fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(giftData),
            });
    
            const giftResponse1 = await giftResponse.json();
            if (!giftResponse.ok) {
              if (giftResponse1.status == 422) {
                this.$refs.gift_wrapping_error.textContent = giftResponse1.description;
                this.loading = false;
                setTimeout(() => {
                  this.$refs.gift_wrapping_error.textContent = "";
                }, 5000);
              }
              return;
            }
          }
          const findStartupCostProduct = document.querySelector(".startup-cost")?.getAttribute("data-id");
          const productSCFee = document.querySelector(".startup-cost")?.getAttribute("data-price");
          let formDataStartupCost = false;
          let formRemoveStartupCost = false;
          
          if (findStartupCostProduct) {
            const existedStartupCostId = document.querySelector("#CartDrawer .item-startup-cost-hidden")?.getAttribute("data-id");
            const existedStartupCostFee = document.querySelector("#CartDrawer .item-startup-cost-hidden")?.getAttribute("data-price");
            if (existedStartupCostId && existedStartupCostFee) {
              if (productSCFee > existedStartupCostFee) {
                formRemoveStartupCost = {
                  id: existedStartupCostId,
                  quantity: 0,
                  'sections': Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                };
                formDataStartupCost = {
                  items: [
                    {
                      id: findStartupCostProduct,
                      quantity: 1,
                      properties: {
                        _is_startup_cost: true,
                      }
                    }
                  ],
                  sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
                };
              } 
            } else {
              formDataStartupCost = {
                items: [
                  {
                    id: findStartupCostProduct,
                    quantity: 1,
                    properties: {
                      _is_startup_cost: true
                    }
                  }
                ],
                sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
              };
            }
          }    
          let formData = new FormData(this.$refs.product_form);
          formData.append(
            'sections',
            Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          await fetch('/cart/add', {
            method:'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData
          }).then(reponse => {
            return reponse.json();
          }).then((response) => {
            if (response.status == '422') {
              if (typeof response.errors == 'object') {
                this.error_message_wrapper = response.errors;
                document.querySelector('.recipient-error-message').classList.remove('hidden');
              } else {
                this.errorMessage = true;
                if(this.$refs.error_message){
                  this.$refs.error_message.textContent = response.description;
                }
              }
            } else {
              if (formDataStartupCost) {
                if (formRemoveStartupCost) {
                  setTimeout(() => {  
                    this.remmoveItemFee(formRemoveStartupCost);
                  }, 500);
                }
                this.addItemFee(formDataStartupCost);
              } else {
                this._postUpdateItem(response);
              }
            }
          }).catch((error) => {
            console.error('Error:', error);
          }).finally(() => {
            this.loading = false;
            if(this.$refs.gift_wrapping_checkbox) this.$refs.gift_wrapping_checkbox.checked = false;
          }) 
        },
        _postUpdateItem(response) {
          document.querySelector('.recipient-error-message') ? document.querySelector('.recipient-error-message').classList.add('hidden') : '';
          this.error_message_wrapper = {};

          Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
          const sectionElement = document.querySelector(section.selector);
            if (sectionElement) {
              if (response.sections[section.id])
                sectionElement.innerHTML = getSectionInnerHTML(response.sections[section.id], section.selector);
              }
          }));
          if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
            Alpine.store('xQuickView').show = false;
          }
          Alpine.store('xPopup').open = false;
          Alpine.store('xMiniCart').openCart();
              
          Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
          document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
        },
        async remmoveItemFee(formRemoveStartupCost) {
          const formResponse = await window.fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formRemoveStartupCost),
          })
          const response = await formResponse.json();
          this._postUpdateItem(response);  
        },
        async addItemFee(formData) {
          const formResponse = await window.fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(formData),
          });
          const response = await formResponse.json();
          this._postUpdateItemFee(response);  
        },
        _postUpdateItemFee(parsedState) {
          if (parsedState.status == '422') {
            console.log(parsedState.message);
          } else {
            const items = document.querySelectorAll('.cart-item');
            Alpine.store('xCartHelper').getSectionsToRender().forEach((section => {
            const sectionElement = document.querySelector(section.selector);
              if (sectionElement) {
                if (parsedState.sections[section.id])
                  sectionElement.innerHTML = getSectionInnerHTML(parsedState.sections[section.id], section.selector);
              }
            }));
            const currentItemCount = Alpine.store('xCartHelper').currentItemCount
            Alpine.store('xCartHelper').currentItemCount = parsedState.item_count;
            if (currentItemCount != parsedState.item_count) {
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            }
            Alpine.store('xPopup').open = false;
            Alpine.store('xMiniCart').openCart();
          }
        },
      })) 
    });
  });
}
